import type { ComponentProps } from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import { TYPOGRAPHY_LINE_HEIGHT_CSS_VAR } from 'LuxKit/Typography/Typography'
import { setCSSVar } from 'lib/theme/themeUtils'

/*
 * The design pins the widget title to 16px at every width: H6/Bold (16/19) on
 * mobile, Body Large/Bold (16/24) from tablet. LuxKit's heading5 is 16px only
 * below tablet and steps up to 18px above it, so the size is held here rather
 * than left to scale.
 *
 * The repeated selector is load-bearing. Heading scopes its own sizes as
 * .hash.variant-heading5 -- two classes -- so a single class here loses, and a
 * doubled one only ties and then leans on injection order.
 */
const StyledHeading = styled(Heading)`
  &&& {
    ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '19px')}

    ${mediaQueryUp.tablet} {
      font-size: 16px;
    }
  }
`

interface Props extends Omit<ComponentProps<typeof Heading>, 'variant'> {}

/**
 * The title row shared by every chat widget: hotels, experiences, cruises and
 * flights. The variant is fixed here because the size pin above is only correct
 * for heading5.
 */
function ChatWidgetHeading(props: Props) {
  return <StyledHeading {...props} variant="heading5" />
}

export default ChatWidgetHeading
